import styled from 'styled-components';
import colors from 'constants/colors';

export const Container = styled.div`

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    row-gap: 10px;
    width: 370px;
    min-height: 120px;
    padding: 16px;
    border: 1px solid ${colors.dimGrey};
    background-color: ${colors.black2};

    .createdAt {
      color: ${colors.white};
      font-size: 12px;
      font-weight: 400;
    }

    .createdBy {
      color: ${colors.green};
      font-size: 14px;
      font-weight: 600;
    }

    .tooltip-title {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      column-gap: 5px;
      color: ${colors.white};
      font-size: 12px;
      font-weight: 400;
    }

    .tooltip-text {
      color: ${colors.white};
      font-size: 14px;
      font-weight: 600;
      white-space: normal;
      word-wrap: break-word;
    }

    .tooltip-highlight {
      color: ${colors.red};
      font-size: 14px;
      font-weight: 600;
    }
`;
